const UA = () => {
    return window.navigator.userAgent;
};
/**
 * 是否为58同城APP环境
 *
 * @returns
 */
export function isWBAPP(): boolean {
    /**
     * 优先排除赶集APP，因为赶集APP的UA头中也会包含wuba信息
     * example（赶集APP）：Mozilla/5.0 (Linux; Android 11; V2046A Build/RP1A.200720.012; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/83.0.4103.106 Mobile Safari/537.36; WUBA/10.2.0; GANJI/10.18.01）
     */
    if (isGJAPP()) return false;

    /**
     * 排除鸿蒙APP
     */
    if (isHMAPP()) return false;

    /**
     * 因为正常情况下58APP、同镇APP载体功能保持一致，所以默认58包含同镇；如果有特殊需求可以先通过`isTZAPP`判断是否为同镇进行准确区分
     */
    if (isTZAPP()) return true;

    return /wuba/i.test(UA());
}

/**
 * 是否为赶集APP环境
 *
 * @returns
 */
export function isGJAPP(): boolean {
    return /ganji/i.test(UA());
}

/**
 * 是否为58同镇APP环境
 *
 * @returns
 */
export function isTZAPP(): boolean {
    return /wbutown/i.test(UA());
}
/**
 * 是否为招才猫环境
 *
 * @returns
 */
export function isZCMAPP(): boolean {
    return /bangJob/i.test(UA());
}

/**
 * 是否为鸿蒙 APP 环境
 *
 * @returns
 */
export function isHMAPP(): boolean {
    return /ArkWeb/i.test(UA());
}
/**
 * 是否为微信小程序环境
 *
 * @returns boolean
 */
export function isWeChatMiniProgram(): boolean {
    // 优先排除支付宝小程序，因为支付宝小程序的UA头中也会包含 MiniProgram 信息
    if (isAlipayMiniProgram()) return false;
    /**
     *
     * 从微信7.0.0开始，可以通过判断userAgent中包含miniProgram字样来判断小程序web-view环境，微信7.0.0以下版本遵循以下规则：
     *
     * android: userAgent 中都会包含MiniProgram 字段；eg：Mozilla/5.0 (Linux; Android 7.0; Mi-4c Build/NRD90M; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/53.0.2785.49 Mobile MQQBrowser/6.2 TBS/043632 Safari/537.36 MicroMessenger/6.6.1.1220(0x26060135) NetType/WIFI Language/zh_CN MicroMessenger/6.6.1.1220(0x26060135) NetType/WIFI Language/zh_CN miniProgram
     *
     * ios高版本：ios高版本userAgent中会包含 MiniProgram 字段；eg：Mozilla/5.0 (iPhone; CPU iPhone OS 16_5 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 MicroMessenger/8.0.37(0x1800252c) NetType/WIFI Language/zh_CN miniProgram/wxa9a9dec97e6ee639
     *
     * ios低版本：低版本只包含 MicroMessenger 字段；eg：Mozilla/5.0 (iPhone; CPU iPhone OS 11_2_1 like Mac OS X) AppleWebKit/604.4.7 (KHTML, like Gecko) Mobile/15C153 MicroMessenger/6.6.1 NetType/WIFI Language/zh_CN
     */

    const isHasMiniProgram = /MiniProgram/i.test(UA());

    const isHasWeCaht = /MicroMessenger/i.test(UA());

    //如果UA中包含MiniProgram，则一定是微信小程序环境
    if (isHasMiniProgram) return true;

    //hack：兼容微信7.0.0以下版本低版本IOS系统
    //@ts-ignore
    return isHasWeCaht && window?.__wxjs_environment === 'miniprogram';
}

/**
 * 是否为支付宝小程序环境
 *
 * @returns boolean
 */
export function isAlipayMiniProgram(): boolean {
    const isHasAlipayMiniProgram = /Alipay/i.test(UA());

    return isHasAlipayMiniProgram;
}

// 判断是m还是pc
export const browserRedirect = () => {
    const userAgent = window.navigator.userAgent;
    let reg =
        /ipad|pad|pod|iPod|Mobile|BlackBerry|Symbian|Windows Phone|wOSBrowser|WebOS|BrowserNG|Fennec|JUC|MQQBrowser|IEMobile|phone|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile|ios|symbianos/i;
    // return reg.test(userAgent.toLowerCase()) ? 'm' : 'pc'
    return 'pc';
};

// 获取平台环境
export const getContext = () => {
    if (isWBAPP()) {
        return 'wuba';
    }
    if (isGJAPP()) {
        return 'ganji';
    }
    if (isZCMAPP()) {
        return 'zcm';
    }
    if (isHMAPP()) {
        return 'harmony';
    }
    if (isTZAPP()) {
        return 'wbutown';
    }
    if (isAlipayMiniProgram() || isWeChatMiniProgram()) {
        return 'miniProgram';
    }
    return browserRedirect();
};

// // 获取平台环境
// export const isContext = getContext();
